<template>
    <section class="hubzone spacer">
        <vue-headful
            title="What are HUBZones | HUBZone Certification Consultants"
            description="The HUBZone Certification Program is a SBA program for companies that have an office in and employ people in Historically Underutilized Business Zones (HUBZones). They are dedicated to building up communities, creating jobs, and supporting the local economy."
            url='https://www.fedsight.com/Why-Choose-Hubzone-Certified-Companies'
        />
        <section class='container-fluid hubzoneHero d-flex align-items-center justify-content-center'>
        </section>

        <section class='mainParagraph'>
            <div class='container'>
                <h1 class='fedsightGreen'>Why Working With a HUBZone Certified Contractor Matters</h1>
                <p><i>Since 1953, the SBA has worked to ignite change and spark action so small businesses can confidently start, grow, expand, or recover.</i> - <a href='https://www.sba.gov/federal-contracting/contracting-assistance-programs/hubzone-program' target='_blank' rel='noreferrer'>United States Small Business Administration (SBA)</a></p> 
            </div>
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    What is the HUBZone Program?
                </h2>
                <p>
                    The HUBZone Program is an SBA program for companies that have an office in and employ people living in Historically Underutilized Business Zones (HUBZones). HUBZone Small Businesses are dedicated to building up communities, creating jobs, and supporting the local economy. 
                </p>
                <p>
                    The SBA provides preferential consideration to HUBZone small businesses, which in turn, promotes job growth, capital investment and economic development in economically distressed areas.
                </p>
                <h2 class='fedsightBlue'>
                    What types of contracts do HUBZone companies' qualify for?
                </h2>
                <p>
                     <a href='https://www.bizfilings.com/toolkit/research-topics/running-your-business/government-contracting/hubzone-can-assist-small-businesses-located-in-distressed-business-zones' target='_blank' rel='noreferrer'>Biz Filings</a> summarized the following:
                </p>
                <div style='padding: 0rem 2rem;'>
                    <p>
                        <strong>A competitive HUBZone contract</strong> can be awarded if the Contracting Officer has a reasonable expectation that at least two qualified HUBZone small businesses will submit offers and that the contract can be awarded at a fair market price.
                    </p>
                    <p>
                        <strong>A sole source HUBZone contract</strong> can be awarded if the Contracting Officer does not have a reasonable expectation that two or more qualified HUBZone small businesses will submit offers, determines that the qualified HUBZone small business is responsible, and determines that the contract can be awarded at a fair price. The government estimate cannot exceed $5 million for manufacturing purchases or $3 million for all other requirements.
                    </p>
                    <p>
                        <strong>A full and open competition contract</strong> can be awarded with a price evaluation preference. The offer of the HUBZone small business will be considered lower than the offer of a non-HUBZone/non-small business, providing that the offer of the HUBZone small business is not more than 10 percent higher than that of the non-HUBZone business.
                    </p>
                    <p>
                        <strong>A subcontract</strong> could be awarded by a large prime contractor. Federal rules require these contractors to include HUBZone contracting goals.
                    </p>
                </div>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'hubzone',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/Why-Choose-Hubzone-Certified-Companies'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
      document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.hubzoneHero{
    height: 25rem;
    background-image: url('./blogAssets/hubzone.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 10rem;
    max-width: 65rem;
}
.hubzoneHeader{
    color: #fff;
    font-size: 6rem;
}
.mainParagraph{
    padding: 8rem 0rem 2rem;
    max-width: 80rem;
    margin: auto;
    text-align: left;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    .hubzoneHero{
      justify-content: center !important;
      background-position: left bottom;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>